import { render } from "./InscricaoPage.vue?vue&type=template&id=add47a12&scoped=true"
import script from "./InscricaoPage.vue?vue&type=script&lang=js"
export * from "./InscricaoPage.vue?vue&type=script&lang=js"

import "./InscricaoPage.vue?vue&type=style&index=0&id=add47a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add47a12"]])

export default __exports__